import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-checkbox"
}
const _hoisted_2 = ["checked"]
const _hoisted_3 = {
  for: "bank_transfer_id",
  class: "c-checkbox__label-radio flex items-center mb-4 cursor-pointer border border-silver pr-x3 pl-50 py-x2 ml-0"
}
const _hoisted_4 = { class: "ml-6" }

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { PaymentProvider, usePaymentOptions } from '@/shared/checkout/usePaymentOptions';
import { useCheckout } from '@/b2b/checkout/useCheckout';
import useAltaPay from '@/shared/checkout/altapay/useAltaPay';
import { computed, onMounted } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPaymentBankTransfer',
  setup(__props) {

const { setSelectedProvider, selectedProvider, isBankTransferProviderSelected } = usePaymentOptions();
const { isAllowedBankTransfer } = useCheckout();
const { initialized, isAllowedOnlinePayment } = useAltaPay();
const labels = useBlockLabels();

const select = () => {
    setSelectedProvider(PaymentProvider.BankTransfer);
};

const showOption = computed(() => {
    const hasPendingOnlinePaymentInitialization = isAllowedOnlinePayment.value && !initialized.value;
    return isAllowedBankTransfer.value && !hasPendingOnlinePaymentInitialization;
});

onMounted(() => {
    if (isAllowedBankTransfer.value && selectedProvider.value === undefined) {
        setSelectedProvider(PaymentProvider.BankTransfer);
    }
});


return (_ctx: any,_cache: any) => {
  return (_unref(showOption))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("input", {
          id: "bank_transfer_id",
          type: "radio",
          name: "altapay_payment_method_radio",
          value: "banktransfer",
          class: "c-checkbox__field",
          checked: _unref(isBankTransferProviderSelected),
          onChange: select
        }, null, 40, _hoisted_2),
        _createElementVNode("label", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(labels).paymentStepBankTransferPaymentOption), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})